import { baseUrl } from '@/shared/constants'
import axios from 'axios'
import { FarcanaAuthResponse, FarcanaStatsResponse } from './types'

export const getFarcanaAuthLink = async (token: string): Promise<FarcanaAuthResponse> => {
  const response = await axios.get(`${baseUrl}/integration/farcana/auth`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getFarcanaStats = async (token: string): Promise<FarcanaStatsResponse> => {
  const response = await axios.get(`${baseUrl}/integration/farcana/statistic`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getShareLink = async (token: string) => {
  const response = await axios.get(`${baseUrl}/integration/share`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
